import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const CaretRightIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M12.6 12L8 7.4L9.4 6L15.4 12L9.4 18L8 16.6L12.6 12Z" />
  </Icon>
)
